/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flat_Sage_Crow_ReadInputs */

const en_flat_sage_crow_read = /** @type {(inputs: Flat_Sage_Crow_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integrations`)
};

const de_flat_sage_crow_read = /** @type {(inputs: Flat_Sage_Crow_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integrationen`)
};

/**
* | output |
* | --- |
* | "Integrations" |
*
* @param {Flat_Sage_Crow_ReadInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const flat_sage_crow_read = /** @type {((inputs?: Flat_Sage_Crow_ReadInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flat_Sage_Crow_ReadInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_flat_sage_crow_read(inputs)
	return de_flat_sage_crow_read(inputs)
});